import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
import faCoins from '@fortawesome/fontawesome-free-solid/faPiggyBank';
// import faGlobe from '@fortawesome/fontawesome-free-solid/faGlobe';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
import faUsers from '@fortawesome/fontawesome-free-solid/faUsers';
// import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
// import faCaretUp from '@fortawesome/fontawesome-free-solid/faCaretUp';
// import faLongArrowAltUp from '@fortawesome/fontawesome-free-solid/faLongArrowAltUp';
// import faLongArrowAltDown from '@fortawesome/fontawesome-free-solid/faLongArrowAltDown';

// import faEye from '@fortawesome/fontawesome-free-solid/faEye';
import faBinoculars from '@fortawesome/fontawesome-free-solid/faBinoculars';
import faCouch from '@fortawesome/fontawesome-free-solid/faCouch';
// import faCoffee from '@fortawesome/fontawesome-free-solid/faCoffee';
import faWifi from '@fortawesome/fontawesome-free-solid/faWifi';
// import faCompass from '@fortawesome/fontawesome-free-solid/faCompass';
// import faCompass from '@fortawesome/fontawesome-free-solid/faMapMarker';
import faCompass from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt';
// import faCompass from '@fortawesome/fontawesome-free-solid/faMapPin';
// import faCompass from '@fortawesome/fontawesome-free-solid/faMapSigns';
import faBath from '@fortawesome/fontawesome-free-solid/faBath';
// import faShower from '@fortawesome/fontawesome-free-solid/faShower';
import faUtensils from '@fortawesome/fontawesome-free-solid/faUtensils';
// import faBed from '@fortawesome/fontawesome-free-solid/faBed';


import deptoNuevo1 from '../images/depto-nuevo/image-8.jpg';
import deptoNuevo2 from '../images/depto-nuevo/image-1.jpg';
import deptoNuevo3 from '../images/depto-nuevo/image-2.jpg';
import deptoNuevo4 from '../images/depto-nuevo/image-3.jpg';
import deptoNuevo5 from '../images/depto-nuevo/image-4.jpg';
import deptoNuevo6 from '../images/depto-nuevo/image-5.jpg';
import deptoNuevo7 from '../images/depto-nuevo/image-6.jpg';
import deptoNuevo8 from '../images/depto-nuevo/image-7.jpg';
import deptoNuevo9 from '../images/depto-nuevo/image-9.jpg';

import deptoUp1 from '../images/depto-64/image-7.jpg';
import deptoUp2 from '../images/depto-64/image-1.jpg';
import deptoUp4 from '../images/depto-64/image-3.jpg';
import deptoUp5 from '../images/depto-64/image-4.jpg';
import deptoUp6 from '../images/depto-64/image-5.jpg';
import deptoUp7 from '../images/depto-64/image-6.jpg';
import deptoUp8 from '../images/depto-64/image-8.jpg';

import deptoDown1 from '../images/depto-54/image-7.jpg';
import deptoDown2 from '../images/depto-54/image-1.jpg';
import deptoDown3 from '../images/depto-54/image-2.jpg';
import deptoDown4 from '../images/depto-54/image-3.jpg';
import deptoDown6 from '../images/depto-54/image-5.jpg';
import deptoDown7 from '../images/depto-54/image-6.jpg';

export const accomodationDetailsEn = {
    header: {
        pageTitle: 'La Serena Full Apartments',
        mapCenter: {lat: -29.925, lng: -71.275},
        markers: [
            {
                markerId: 'marker-1',
                markerText: 'Apartments La Serena Full',
                markerLat: -29.90,
                markerLon: -71.263
            }, {
                markerId: 'marker-2',
                markerText: 'New Apartment with spectacular ocean view',
                markerLat: -29.938,
                markerLon: -71.283
            }],
        menuItems: [
            {
            id: 1,
            href: '#highlight',
            title: 'Highlights'
            },
            {
            id: 2,
            href: '#accommodation',
            title: 'Accommodation'
            },
            // {
            // id: 3,
            // href: '#photos',
            // title: 'Photos'
            // },
            {
            id:4,
            href: '#contact',
            title: 'Contacts'
            }
        ],
        sliderPhotos: [
            {
            sliderPhotoId: 1,
            sliderPhotoName: 'acc',
            sliderPhotoURI: deptoNuevo1
            }
        ]
    },
    headings: {
        h1: 'Our Accommodation',
        h2: 'Contacts',
        h3: 'Contact Form'
    },
    highlights: {
        briefDesc: 'Fully furnished apartments with sheets, towels, wifi, cable, parking. Ten minutes from the beach and close to La Serena city centre with its historic churches and fantastic vegetable and handycraft market.',
        highlightBoxes: [
            {
                key: 'feature-1',
                value: 'Fantastic location',
                faicon: faCompass,
                iconSize: '2x'
            },{
                key: 'feature-2',
                value: 'Bathtub in bathroom',
                faicon: faBath,
                iconSize: '2x'
            },{
                key: 'feature-3',
                value: 'Super fast Wi-Fi',
                faicon: faWifi,
                iconSize: '2x'
            },{
                key: 'feature-4',
                value: 'Relax on balcony',
                faicon: faCouch,
                iconSize: '2x'
            },{
                key: 'feature-5',
                value: 'Amazing view',
                faicon: faBinoculars,
                iconSize: '2x'
            },{
                key: 'feature-6',
                value: 'Well equiped kitchen',
                faicon: faUtensils,
                iconSize: '2x'
            }
        ]
    },
    photoGallery: {

    },
    accDetails: [
        {
            accItemId: 1,
            accItemName: 'New apartment with spectacular ocean view',
            accItemFaicon: faUsers,
            accItemFaiconSize: '1x',
            accItemFaiconCount: 1,
            accItemPriceLow: '60 USD',
            accItemPriceHigh: '115 USD',
            accItemDesc: 'Spectacular new apartment overlooking the sea. Suitable for 4 people. There are two bathrooms, kitchen, cable TV, wireless internet. On the roof of the building there is a large terrace with  barbecue. There is a spectacular pool in the grounds too. Area is wih private parking and a concierge 24 hours. All this only steps from the beach of La Serena and restaurants. You can walk to the Casino Enjoy de Peñuelas, enjoy walks along the Avenida del Mar and La Serena beach. This is a first category apartment for 4 people, new, with all its utensils and a second line view of the sea to the port of Coquimbo, 600 meters of restaurants and Casino Enjoy. I can help the guests in case of any problem or desire. I can give some recommendations about the area and the restaurants too.',
            accItem360Text: 'Please check our 360 degree photography: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/iMnRRNQnMIoCkQYvgiLPBvioi"
                },{
                    photoId: "three-sixty-2",
                    photoName: "Exterior",
                    url: "https://theta360.com/s/ls9dy9tjCnBPhW8Lb3UzUrMKu"
                }
            ],
            accItemPhotos: [{
                original: deptoNuevo1,
                thumbnail: deptoNuevo1
            },{
                original: deptoNuevo2,
                thumbnail: deptoNuevo2
            },{
                original: deptoNuevo3,
                thumbnail: deptoNuevo3
            },{
                original: deptoNuevo4,
                thumbnail: deptoNuevo4
            },{
                original: deptoNuevo5,
                thumbnail: deptoNuevo5
            },{
                original: deptoNuevo6,
                thumbnail: deptoNuevo6
            },{
                original: deptoNuevo7,
                thumbnail: deptoNuevo7
            },{
                original: deptoNuevo8,
                thumbnail: deptoNuevo8
            },{
                original: deptoNuevo9,
                thumbnail: deptoNuevo9
            }
        ]
        },{
            accItemId: 2,
            accItemName: 'Apartment in La Serena Full',
            accItemFaicon: faUser,
            accItemFaiconSize: '1x',
            accItemFaiconCount: 2,
            accItemPriceLow: '40 USD',
            accItemPriceHigh: '70 USD',
            accItemDesc: 'Independent apartment with one piece in suite with bathroom and walking closet, living room with kitchenette equipped with everything to spend a great time. Apartment near supermarket, historic center and the beach, with private parking. Concierge 24 hours and swimming pool. Independent apartment with an excellent view of the sea, as it is not located on the edge of the beach makes it a much quieter place without tacos and has a supermarket 2 blocks away that makes it very comfortable and attractive. Guests may use the pool in the grounds. I am usually in the same city so there is no problem to contact me in case of any problem.',
            accItem360Text: 'Please check our 360 degree photography: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/rGyVdNeOzmZWdO76xvGrnceVU"
                }
            ],
            accItemPhotos: [{
                original: deptoUp1,
                thumbnail: deptoUp1
            },{
                original: deptoUp2,
                thumbnail: deptoUp2
            },{
                original: deptoUp4,
                thumbnail: deptoUp4
            },{
                original: deptoUp5,
                thumbnail: deptoUp5
            },{
                original: deptoUp6,
                thumbnail: deptoUp6
            },{
                original: deptoUp7,
                thumbnail: deptoUp7
            },{
                original: deptoUp8,
                thumbnail: deptoUp8
            }]
        },{
            accItemId: 3,
            accItemName: 'Apartment in La Serena Full 2',
            accItemFaicon: faUsers,
            accItemFaiconSize: '2x',
            accItemFaiconCount: 1,
            accItemPriceLow: '40 USD',
            accItemPriceHigh: '70 USD',
            accItemDesc: 'Independent apartment with one piece in suite with bathroom and walking closet, living room with kitchenette equipped with everything to spend a great time. Apartment near supermarket, historic center and the beach, with private parking. Concierge 24 hours and swimming pool. Independent apartment with an excellent view of the sea, as it is not located on the edge of the beach makes it a much quieter place without tacos and has a supermarket 2 blocks away that makes it very comfortable and attractive. Guests may use the pool in the grounds. I am usually in the same city so there is no problem to contact me in case of any problem.',
            accItem360Text: 'Please check our 360 degree photography: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/bdcIUBmmJQoZlTg0eWJT2y6YC"
                }
            ],
            accItemPhotos: [{
                original: deptoDown1,
                thumbnail: deptoDown1
            },{
                original: deptoDown2,
                thumbnail: deptoDown2
            },{
                original: deptoDown3,
                thumbnail: deptoDown3
            },{
                original: deptoDown4,
                thumbnail: deptoDown4
            },{
                original: deptoDown6,
                thumbnail: deptoDown6
            },{
                original: deptoDown7,
                thumbnail: deptoDown7
            }]
        }
    ],
    cDetails: [
        // {
        //     label: 'phone',
        //     faicon: faPhone,
        //     value: '+05962345254'
        // },
        {
            label: 'E-mail',
            faicon: faEnvelope,
            value: 'inversionestrinidad28@yahoo.cl'
        },
        {
            label: 'Payment',
            faicon: faCoins,
            value: 'Payment for the reservation would be realized via '
        }
        // ,{
        //     label: 'address',
        //     faicon: faGlobe,
        //     value: 'New Road 5, Puerto Williams, Isla Navarino, Chile'
        // },{
        //     label: 'GPS',
        //     faicon: faCompass,
        //     value: '67.601196, 54.933267'
        // }
    ],
    cFormDetails: {
        text: "Please, leave us a message in case of any question.",
        emailForContact: "patty-hospedaje@yahoo.com",
        nameLabel: "Name",
        emailLabel: "Email",
        messageLabel: "Message",
        messageHint: "Your question or comment",
        submit: "Submit",
        responseMessage: "Thank you for your message!"
    },
    footer: {
        // transferwise: "Payments for accommodation are made using the transferwise service ",
    }
}

export const accomodationDetailsEs = {
    header: {
        pageTitle: 'Departamentos La Serena Full',
        mapCenter: {lat: -29.925, lng: -71.275},
        markers: [
            {
                markerId: 'marker-1',
                markerText: 'Departamentos La Serena Full',
                markerLat: -29.90,
                markerLon: -71.263
            }, {
                markerId: 'marker-2',
                markerText: 'Departamento nuevo con espectacular vista al mar',
                markerLat: -29.938,
                markerLon: -71.283
            }],
        menuItems: [
            {
            id: 1,
            href: '#highlight',
            title: 'Réflejos'
            },
            {
            id: 2,
            href: '#accommodation',
            title: 'Alojamiento'
            },
            // {
            // id: 3,
            // href: '#photos',
            // title: 'Fotos'
            // },
            {
            id:4,
            href: '#contact',
            title: 'Contactos'
            }
        ],
        sliderPhotos: [
            {
            sliderPhotoId: 1,
            sliderPhotoName: 'acc',
            sliderPhotoURI: deptoNuevo1
            }
        ]
    },
    headings: {
        h1: 'Nuestro Alojamiento',
        h2: 'Contactos',
        h3: 'Formulario de Contacto'
    },
    highlights: {
        briefDesc: 'Departamentos completos con sabanas, toallas, wifi, cable, estacionamiento. A diez minutos de la playa y cerca del centro de La Serena, con sus iglesias históricas y su fantástico mercado de verduras y artesanías.',
        highlightBoxes: [
            {
                key: 'feature-1',
                value: 'Fantástica ubicación',
                faicon: faCompass,
                iconSize: '2x'
            },{
                key: 'feature-2',
                value: 'Bañera en el baño',
                faicon: faBath,
                iconSize: '2x'
            },{
                key: 'feature-3',
                value: 'Wi-Fi superrápido',
                faicon: faWifi,
                iconSize: '2x'
            },{
                key: 'feature-4',
                value: 'Relajar en balcón',
                faicon: faCouch,
                iconSize: '2x'
            },{
                key: 'feature-5',
                value: 'Increíble vista',
                faicon: faBinoculars,
                iconSize: '2x'
            },{
                key: 'feature-6',
                value: 'Cocina bien equipada',
                faicon: faUtensils,
                iconSize: '2x'
            }
        ]
    },
    photoGallery: {

    },
    accDetails: [
        {
            accItemId: 1,
            accItemName: 'Departamento nuevo con espectacular vista al mar',
            accItemFaicon: faUsers,
            accItemFaiconSize: '1x',
            accItemFaiconCount: 1,
            accItemPriceLow: '60 USD',
            accItemPriceHigh: '115 USD',
            accItemDesc: 'Espectacular departamento, nuevo, con vista al mar, para 4 personas, dos baños, cocina equipada, terraza amplia, quincho en la azotea del edificio, con espectacular Piscina, estacionamiento privado, conserjería las 24 horas, Tv Cable, internet Wifi. Todo esto a pasos de la playa de La Serena y restoranes. Se puede ir caminando al casino Enjoy de Peñuelas, disfrutar de paseos por la avenida del mar y la playa de La Serena. El lugar - Es un departamento de primera categoría, nuevo, con todos sus utensilios para 4 personas con una vista en segunda línea al mar a puerto de Coquimbo, queda 600 metros de restoranes y casino Enjoy. Tiene piscina y estacionamiento privado. Disponible para huéspedes - El huésped puede gozar de una excelente piscina y quincho para hacer asado en el último piso. Atención a los huéspedes - Yo generalmente les entregó el departamento para que queden bien ubicados y les puedo ayudar en lo que necesiten, recomendaciones y otros.',
            accItem360Text: 'Por favor, visite nuestro 360 grados fotografía: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/iMnRRNQnMIoCkQYvgiLPBvioi"
                },{
                    photoId: "three-sixty-2",
                    photoName: "Exterior",
                    url: "https://theta360.com/s/ls9dy9tjCnBPhW8Lb3UzUrMKu"
                }
            ],
            accItemPhotos: [{
                original: deptoNuevo1,
                thumbnail: deptoNuevo1
            },{
                original: deptoNuevo2,
                thumbnail: deptoNuevo2
            },{
                original: deptoNuevo3,
                thumbnail: deptoNuevo3
            },{
                original: deptoNuevo4,
                thumbnail: deptoNuevo4
            },{
                original: deptoNuevo5,
                thumbnail: deptoNuevo5
            },{
                original: deptoNuevo6,
                thumbnail: deptoNuevo6
            },{
                original: deptoNuevo7,
                thumbnail: deptoNuevo7
            },{
                original: deptoNuevo8,
                thumbnail: deptoNuevo8
            },{
                original: deptoNuevo9,
                thumbnail: deptoNuevo9
            }]
        },{
            accItemId: 2,
            accItemName: 'Arriendo en La Serena departamentos full',
            accItemFaicon: faUser,
            accItemFaiconSize: '1x',
            accItemFaiconCount: 2,
            accItemPriceLow: '40 USD',
            accItemPriceHigh: '70 USD',
            accItemDesc: 'Apartamento independiente con una pieza en suite con baño y walking closet, sala de estar con cocina equipada con todo para pasar un buen rato. Apartamento cerca de supermercado, centro histórico y la playa, con aparcamiento privado. Conserje las 24 horas y piscina. Apartamento independiente con una excelente vista al mar, ya que no está ubicado en el borde de la playa hace que sea un lugar mucho más tranquilo sin tacos y tiene un supermercado a 2 cuadras que lo hace muy cómodo y atractivo.  Las dependencias del edificio cuentan con Piscina. Normalmente estoy en la misma ciudad, así que no hay problema para contactarme en caso de algún problema.',
            accItem360Text: 'Por favor, visite nuestro 360 grados fotografía: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/rGyVdNeOzmZWdO76xvGrnceVU"
                }
            ],
            accItemPhotos: [{
                original: deptoUp1,
                thumbnail: deptoUp1
            },{
                original: deptoUp2,
                thumbnail: deptoUp2
            },{
                original: deptoUp4,
                thumbnail: deptoUp4
            },{
                original: deptoUp5,
                thumbnail: deptoUp5
            },{
                original: deptoUp6,
                thumbnail: deptoUp6
            },{
                original: deptoUp7,
                thumbnail: deptoUp7
            },{
                original: deptoUp8,
                thumbnail: deptoUp8
            }]
        },{
            accItemId: 3,
            accItemName: 'Arriendo en La Serena departamentos full 2',
            accItemFaicon: faUsers,
            accItemFaiconSize: '2x',
            accItemFaiconCount: 1,
            accItemPriceLow: '40 USD',
            accItemPriceHigh: '70 USD',
            accItemDesc: 'Apartamento independiente con una pieza en suite con baño y walking closet, sala de estar con cocina equipada con todo para pasar un buen rato. Apartamento cerca de supermercado, centro histórico y la playa, con aparcamiento privado. Conserje las 24 horas y piscina. Apartamento independiente con una excelente vista al mar, ya que no está ubicado en el borde de la playa hace que sea un lugar mucho más tranquilo sin tacos y tiene un supermercado a 2 cuadras que lo hace muy cómodo y atractivo. Las dependencias del edificio cuentan con Piscina. Normalmente estoy en la misma ciudad, así que no hay problema para contactarme en caso de algún problema.',
            accItem360Text: 'Por favor, visite nuestro 360 grados fotografía: ',
            accItem360: [
                {
                    photoId: "three-sixty-1",
                    photoName: "Interior",
                    url: "https://theta360.com/s/bdcIUBmmJQoZlTg0eWJT2y6YC"
                }
            ],
            accItemPhotos: [{
                original: deptoDown1,
                thumbnail: deptoDown1
            },{
                original: deptoDown2,
                thumbnail: deptoDown2
            },{
                original: deptoDown3,
                thumbnail: deptoDown3
            },{
                original: deptoDown4,
                thumbnail: deptoDown4
            },{
                original: deptoDown6,
                thumbnail: deptoDown6
            },{
                original: deptoDown7,
                thumbnail: deptoDown7
            }]
        }
    ],
    cDetails: [
        // {
        //     label: 'teléphono',
        //     faicon: faPhone,
        //     value: '+05962345254'
        // },
        {
            label: 'E-mail',
            faicon: faEnvelope,
            value: 'inversionestrinidad28@yahoo.cl'
        },
        {
            label: 'Pago',
            faicon: faCoins,
            value: 'El pago de la reserva se realizará a través del servicio '
        }
        // },{
        //     label: 'dirección',
        //     faicon: faGlobe,
        //     value: 'New Road 5, Puerto Williams, Isla Navarino, Chile'
        // },{
        //     label: 'GPS',
        //     faicon: faCompass,
        //     value: '67.601196, 54.933267'
        // }
    ],
    cFormDetails: {
        text: "Por favor, déjanos un mensaje en caso de cualquier pregunta.",
        emailForContact: "patty-hospedaje@yahoo.com",
        nameLabel: "Nombre",
        emailLabel: "E-mail",
        messageLabel: "Mensaje",
        messageHint: "Su pregunta o comentario",
        submit: "Enviar",
        responseMessage: "Gracias por tu mensaje!"
    },
    footer: {
        // transferwise: "Los pagos de alojamiento se realizan utilizando el servicio ",
    }
}


// WEBPACK FOOTER //
// ./src/data/data.js